"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useShoppingBag = void 0;
var _react = require("react");
var _context = require("../../../context");
const useShoppingBag = () => {
  const {
    setSessionId
  } = (0, _context.useAppConfig)();
  const [shoppingBagQuantity, setShoppingBagQuantity] = (0, _react.useState)(0);
  const [isReceivedShoppingContext, setIsReceivedShoppingContext] = (0, _react.useState)(false);
  const updateShoppingBagQuantity = (0, _react.useCallback)(newQuantity => {
    if (newQuantity >= 0) {
      setShoppingBagQuantity(newQuantity);
    }
  }, []);
  const onShoppingContextLoaded = (0, _react.useCallback)(event => {
    updateShoppingBagQuantity(event.detail.shoppingBag.shoppingBagQuantity);
    setIsReceivedShoppingContext(true);
    setSessionId(event.detail.sessionId ?? undefined);
  }, [setSessionId, updateShoppingBagQuantity]);
  const onBasketUpdated = (0, _react.useCallback)(event => {
    updateShoppingBagQuantity(event.detail.shoppingBag.shoppingBagQuantity);
  }, [updateShoppingBagQuantity]);
  return (0, _react.useMemo)(() => ({
    shoppingBagQuantity,
    isReceivedShoppingContext,
    onShoppingContextLoaded,
    onBasketUpdated
  }), [shoppingBagQuantity, isReceivedShoppingContext, onShoppingContextLoaded, onBasketUpdated]);
};
exports.useShoppingBag = useShoppingBag;